// extracted by mini-css-extract-plugin
export default {"textWrapper":"urfcm"};